// extracted by mini-css-extract-plugin
export var blue = "footer-module--blue--3UdUo";
export var flex = "footer-module--flex--c-0qU";
export var center = "footer-module--center--3jPDX";
export var black = "footer-module--black--3ePaW";